__turbopack_context__.v({
  "box": "ImagePlaceholder-module__5oQaAq__box",
});
